import { motion } from "framer-motion";
import { MaskedLines, Reveal } from "@/components/site/Reveal";
import { AmazonButton, ProductCard } from "@/components/site/ProductCard";
import { EditorialMarquee } from "@/components/site/Marquee";
import { PRODUCTS, AMAZON_STORE } from "@/data/site";

export default function Catalogue() {
  return (
    <>
      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-40 pb-16" data-testid="catalogue-hero">
        <p className="text-xs uppercase tracking-[0.35em] text-rosegold mb-7">The Catalogue</p>
        <h1 className="font-serif text-5xl sm:text-7xl lg:text-8xl leading-[0.92] tracking-tight">
          <MaskedLines lines={["Every Piece,"]} delay={0.2} />
          <MaskedLines lines={["A Little"]} delay={0.32} />
          <MaskedLines lines={["Love Letter."]} delay={0.44} wordClass="italic text-rosegold" />
        </h1>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-xl text-charcoal/60 leading-relaxed text-lg">
            Discover Fashiella on the page you love, then complete your purchase on Amazon. No baskets, no fuss —
            just beautiful accessories, a tap away.
          </p>
        </Reveal>
      </section>

      <EditorialMarquee items={["Handmade With Love", "Timeless Elegance", "Fashiella"]} />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20" data-testid="catalogue-grid">
        <div className="grid gap-x-7 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.05, ease: [0.22, 1, 0.36, 1] }}
            >
              <ProductCard product={p} index={i} />
            </motion.div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-32" data-testid="catalogue-cta">
        <Reveal>
          <div className="bg-nude/60 px-6 sm:px-16 py-20 text-center">
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight">Looking for more?</h2>
            <p className="mt-5 max-w-md mx-auto text-charcoal/60 leading-relaxed">
              Our full range lives on Amazon — new pieces added with love.
            </p>
            <div className="mt-9 flex justify-center">
              <AmazonButton href={AMAZON_STORE} label="Visit Amazon Store" testid="catalogue-amazon-btn" />
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
